import React from 'react';
import styled from 'styled-components';
import { Breadcrumbs, BackLink } from 'components/Shared';
const headerContainerHeight = 130;
const headerContainerHeightMobile = 90;
const HeaderContainer = styled.div `
  position: relative;
  z-index: 1;
  padding: 30px 16px 10px 0;
  background: ${({ transparent }) => (transparent ? 'transparent' : '#fff')};
  ${({ dynamicHeight }) => dynamicHeight && `height: ${headerContainerHeight}px;`}

  ${({ mobile, dynamicHeight }) => mobile &&
    `
    ${dynamicHeight && `height: ${headerContainerHeightMobile}px;`}
    padding: 16px 16px 10px 0;
  `}
`;
const SlideHeader = ({ breadcrumbs, onPrev, mobile, labelBackLink, renderOnImpactClaims, dynamicHeight, backToStartCrumb, }) => {
    return (React.createElement(HeaderContainer, { mobile: mobile, transparent: renderOnImpactClaims, dynamicHeight: dynamicHeight },
        !mobile && !!onPrev && (React.createElement(BackLink, { label: labelBackLink, action: onPrev, color: renderOnImpactClaims && '#fff' })),
        React.createElement(Breadcrumbs, { config: breadcrumbs, mobile: mobile, backToStartCrumb: backToStartCrumb })));
};
export default SlideHeader;
